export const SPEECH_BUBBLE_TAIL_START = 'start' as const;
export const SPEECH_BUBBLE_TAIL_TOP = 'top' as const;
/** A corner tail under the bubble's first edge, for a speaker below and before it. */
export const SPEECH_BUBBLE_TAIL_BOTTOM_START = 'bottom-start' as const;
/** A corner tail under the bubble's last edge, for a speaker below and after it. */
export const SPEECH_BUBBLE_TAIL_BOTTOM_END = 'bottom-end' as const;

export type SpeechBubbleTail =
  | typeof SPEECH_BUBBLE_TAIL_START
  | typeof SPEECH_BUBBLE_TAIL_TOP
  | typeof SPEECH_BUBBLE_TAIL_BOTTOM_START
  | typeof SPEECH_BUBBLE_TAIL_BOTTOM_END;

export const SPEECH_BUBBLE_SIZE_MEDIUM = 'medium' as const;
export const SPEECH_BUBBLE_SIZE_SMALL = 'small' as const;
export type SpeechBubbleSize = typeof SPEECH_BUBBLE_SIZE_MEDIUM | typeof SPEECH_BUBBLE_SIZE_SMALL;
